__turbopack_context__.v({
  "itinerarySection": "ItinerarySection-module__cszI1q__itinerarySection",
  "itinerarySkeleton": "ItinerarySection-module__cszI1q__itinerarySkeleton",
});
